import request from "../axios";

export function queryIndexDataApi() {
    return request({
        url: "/index/data/query",
        method: 'GET'
    })
}